import { Save, X } from "lucide-react";
import userApi from "../../../../api/userApi";
import { useEffect, useState } from "react";
import { useNotification } from "../../../../hooks/useNotification";

export default function AddRoleStaffModal({
  isOpen,
  setIsOpen,
  shop,
  staffs,
  getStaffs,
  checkedRoles,
}) {
  const { addNotification } = useNotification();
  const [selectedRole, setSelectedRole] = useState("admin");
  const [tempStaffs, setTempStaffs] = useState([]);

  const handleStaffChange = (e, id) => {
    if (e.target.checked) {
      setTempStaffs(
        tempStaffs.map((x) =>
          x._id === id
            ? {
                ...x,
                shopRoles: x.shopRoles.find((sr) => sr.shopId === shop._id)
                  ? x.shopRoles.map((sr) =>
                      sr.shopId === shop._id
                        ? { ...sr, role: selectedRole }
                        : sr
                    )
                  : [
                      ...x.shopRoles,
                      {
                        shopId: shop._id,
                        role: selectedRole,
                        permissions: ["view_all", ...checkedRoles],
                      },
                    ],
              }
            : x
        )
      );
    } else {
      setTempStaffs(
        tempStaffs.map((x) =>
          x._id === id
            ? {
                ...x,
                shopRoles: x.shopRoles.filter((sr) => sr.shopId !== shop._id),
              }
            : x
        )
      );
    }
  };

  const handleCloseClick = () => {
    setIsOpen(false);
    setSelectedRole("admin");
  };

  const handleSaveClick = async () => {
    for (const staff of tempStaffs) {
      await userApi.updateById({
        _id: staff._id,
        shopRoles: staff.shopRoles,
      });
    }
    addNotification("Lưu thành công", 1);
    await getStaffs();
    setIsOpen(false);
    setSelectedRole("admin");
  };

  useEffect(() => {
    setTempStaffs(staffs);
  }, [staffs]);

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-medium text-gray-900">
                Thêm/Xoá nhân viên quản lý Zalo
              </h3>
              <button
                onClick={handleCloseClick}
                className="text-gray-400 hover:text-gray-500 transition-colors duration-200"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4">
              <div className="space-y-6">
                <div>
                  <div className="space-y-6">
                    {/* Role Selection */}
                    <div>
                      <p className="mb-2 font-medium">Chọn quyền:</p>
                      <div className="space-x-4">
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="role"
                            value="admin"
                            checked={selectedRole === "admin"}
                            onChange={(e) => setSelectedRole(e.target.value)}
                            className="w-4 h-4"
                          />
                          <span className="ml-2">Quản trị viên</span>
                        </label>
                        <label className="inline-flex items-center">
                          <input
                            type="radio"
                            name="role"
                            value="editor"
                            checked={selectedRole === "editor"}
                            onChange={(e) => setSelectedRole(e.target.value)}
                            className="w-4 h-4"
                          />
                          <span className="ml-2">Biên tập viên</span>
                        </label>
                      </div>
                    </div>

                    {/* Staff Selection */}
                    <div>
                      <p className="mb-2 font-medium">Chọn nhân viên</p>
                      <div className="border rounded-lg p-2 h-60 overflow-y-auto">
                        {tempStaffs
                          .filter((x) => x.role !== "super_admin")
                          .map((staff) => (
                            <label
                              key={staff._id}
                              className="block p-2 hover:bg-gray-50"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  staff.shopRoles?.find(
                                    (sr) =>
                                      sr.shopId === shop._id &&
                                      sr.role === selectedRole
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  handleStaffChange(e, staff._id)
                                }
                                className="w-4 h-4"
                              />
                              <span className="ml-2">{staff.name}</span>
                            </label>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="flex justify-end">
                  <button
                    className="inline-flex items-center gap-2 rounded-md bg-green-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 transition-colors duration-200"
                    onClick={handleSaveClick}
                  >
                    <Save className="h-4 w-4" />
                    Lưu
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
